<script>
import {
  pageMonCompteMesCommandesEnMagasinEmits,
  pageMonCompteMesCommandesEnMagasinProps,
  usePageMonCompteMesCommandesEnMagasin
} from "./mixin";
import List from "@/components/molecules/list";
import ListItem from "@/components/molecules/list/list-item";
import CommandeMagasinOverview from "@/components/organisms/mon-compte/commande-magasin-overview/mobile";
import Button from "@/components/atoms/button";
import LazyImage from "@/components/atoms/lazy-image";
import Card from "@/components/molecules/card";
import Titre from "@/components/atoms/titre";
import MesAchatsFilters from "@/components/organisms/mon-compte/mes-achat-filters/mobile";
import LoadingSpinner from "@/components/molecules/loading-spinner";
import Icon from "@/components/atoms/icon";
import ButtonIcon from "@/components/molecules/button-icon";
import Popin from "@/components/molecules/popin";
import Badge from "@/components/atoms/badge";
import PopinAnchor from "@/components/molecules/popin-anchor";
import LinkTo from "@/components/atoms/link-to";
import BandeauCommandeEnLigne from "@/components/organisms/bandeau-commande/bandeau-commande-enligne";
import BandeauCommandeMagasin from "@/components/organisms/bandeau-commande/bandeau-commande-magasin";

import noResult from "@/assets/images/mon-compte-achat/no-result.svg";
import teasing from "@/assets/images/mon-compte-achat/teasing.svg";
import noAchat from "@/assets/images/mon-compte-achat/no-achat.svg";
import register from "@/assets/images/mon-compte-achat/register.svg";
import carrefourLoyaltyPassOmbre from "@/assets/images/carrefour-club-pass-card-ombre-incline.svg";

export default {
  name: "MesCommandesEnMagasinMobile",
  components: {
    List,
    BandeauCommandeEnLigne,
    BandeauCommandeMagasin,
    ListItem,
    CommandeMagasinOverview,
    Button,
    LazyImage,
    LinkTo,
    Card,
    Titre,
    MesAchatsFilters,
    Icon,
    ButtonIcon,
    Popin,
    Badge,
    PopinAnchor,
    LoadingSpinner
  },
  props: {
    ...pageMonCompteMesCommandesEnMagasinProps()
  },
  emits: [
    "supprimerToutFiltres",
    "voirPlusAchats",
    ...pageMonCompteMesCommandesEnMagasinEmits()
  ],
  setup(props, context) {
    const {
      isPorteurCarteCora,
      isPorteurCarteMalin,
      appliquerFiltre,
      supprimerFiltre,
      setPopinAjoutCarte,
      canDisplayBanner
    } = usePageMonCompteMesCommandesEnMagasin(context, props);

    return {
      canDisplayBanner,
      isPorteurCarteCora,
      isPorteurCarteMalin,
      appliquerFiltre,
      supprimerFiltre,
      setPopinAjoutCarte,
      noResult,
      teasing,
      noAchat,
      register,
      carrefourLoyaltyPassOmbre
    };
  },
  data() {
    return {
      filterIsVisible: false
    };
  },
  methods: {
    toggleFilter() {
      this.filterIsVisible = !this.filterIsVisible;
    }
  }
};
</script>
<template>
  <BandeauCommandeMagasin v-if="canDisplayBanner" />

  <div>
    <Popin
      :visible="filterIsVisible"
      page
      full-width
      size="xlg"
      title="Affiner ma sélection"
      class="u-bgcolor-white"
    >
      <MesAchatsFilters
        :liste-magasins="listeMagasins"
        :query-filters="queryFilters"
        :applied-filters="appliedFilters"
        :key-periode="keyPeriode"
        @appliquerFiltres="appliquerFiltre"
        @toggleFilter="toggleFilter()"
        @supprimerFiltre="supprimerFiltre"
        @supprimerToutFiltres="$emit('supprimerToutFiltres')"
      />
    </Popin>

    <div
      v-if="filtersDisplay"
      class="u-flex u-flex-justify-between u-flex-align-center u-mt-md"
    >
      <ButtonIcon
        icon-name="equalizer"
        radius="full"
        variant="toggle-filter-mobile"
        icon-color="white"
        icon-color-hover="white"
        icon-position="left"
        icon-size="sm"
        @click="toggleFilter()"
      >
        <span class="u-mr-sm">
          Filtrer
        </span>
        <Badge
          v-if="appliedFilters.length > 0 || queryFilters.garantie === '1' "
          tag="span"
          circle
          variant="white"
          size="sm"
          class="u-color-primary u-font-700 u-font-secondary"
        >
          {{ queryFilters.garantie ? appliedFilters.length + parseInt(queryFilters.garantie) : appliedFilters.length }}
        </Badge>
      </ButtonIcon>
      <PopinAnchor
        popin-size="sm"
        link
        icon-name="help-circle-outline"
        icon-color="primary"
        icon-color-hover="primary-light"
        icon-position="left"
        icon-size="xs03"
        position="bottom-left"
        infobulle
        class="c-filter-achat__info u-mr-md"
      >
        <p class="u-font-14">
          Réglez avec votre carte cora Cpay Mastercard ou présentez votre carte Malin lors de votre passage en caisse, pour retrouver vos tickets de caisse dans cette page.
        </p>
      </PopinAnchor>
    </div>

    <div
      v-if="achatsMagasin.length > 0 || achatIsLoading"
      class="u-pt-md u-px-sm u-pb-sm"
    >
      <List
        v-for="achat in achatsMagasin"
        :key="achat.id"
      >
        <ListItem class="u-mb-sm">
          <CommandeMagasinOverview :commande="achat" />
        </ListItem>
      </List>
      <LoadingSpinner
        v-if="achatIsLoading"
        size="md"
      />
      <div
        v-if="showSeeMoreResults"
        class="u-text-center u-mt-md"
      >
        <Button
          variant="primary"
          radius="full"
          size="md"
          @click="$emit('voirPlusAchats')"
        >
          Voir plus d’achats
        </Button>
      </div>
    </div>

    <Card
      v-if="!achatIsLoading && achatsMagasin.length === 0"
      class="u-mt-lg u-mb-lg"
    >
      <div
        v-if="isFidCarrefour"
        class="u-px-md u-py-lg"
      >
        <div class="u-flex u-flex-column u-flex-align-center u-text-center">
          <LazyImage
            :src="carrefourLoyaltyPassOmbre"
            width="119"
            height="90"
            class="u-inline-block u-flex-shrink-none"
          />
          <div>
            <Titre
              tag="h2"
              size="sm"
              class="u-my-xs"
            >
              Vous ne voyez pas vos achats effectués en magasin ?
            </Titre>
            <p class="u-font-15 u-mt-xs u-mb-sm">
              Retrouvez vos tickets de caisse sur les achats effectués en magasin avec votre Carte Club ou Carte PASS sur <LinkTo to="#">carrefour.fr
                <Icon
                  name="external"
                  size="sm"
                />
              </LinkTo>
            </p>
          </div>
        </div>
      </div>
      <div
        v-else-if="error && error !== 404"
        class="u-px-md u-py-lg"
      >
        <div class="u-flex u-flex-column u-flex-align-center u-text-center">
          <Icon
            variant="alert"
            name="alert-circle-outline"
            size="lg"
            class="u-flex-shrink-none"
          />
          <div>
            <Titre
              tag="h2"
              size="sm"
              class="u-mt-sm u-mb-xs"
            >
              Désolé, une erreur s’est produite
            </Titre>
            <p class="u-font-15">
              Nous n’avons pas réussi à récupérer vos tickets de caisse magasin. Veuillez réessayer plus tard
            </p>
          </div>
        </div>
      </div>
      <div
        v-else-if="achatsMagasin.length === 0 && appliedFilters.length == 0 && queryFilters.garantie === '0' || error === 404"
        class="u-px-md u-py-lg"
      >
        <div class="u-flex u-flex-column u-flex-align-center u-text-center">
          <LazyImage
            :src="noAchat"
            width="135"
            class="u-inline-block u-mr-md"
          />
          <div>
            <Titre
              tag="h2"
              size="sm"
              class="u-my-xs"
            >
              Vous n’avez pas encore effectué d’achat en présentant votre carte en magasin
            </Titre>
            <p class="u-font-15">
              Réglez avec votre carte cora Cpay Mastercard ou présentez votre carte Malin lors de votre passage en caisse, pour retrouver vos tickets de caisse dans cette page.
            </p>
          </div>
        </div>
      </div>
      <div
        v-else-if="isMagasinTeasing"
        class="u-px-md u-py-lg"
      >
        <div class="u-flex u-flex-column u-flex-align-center u-text-center">
          <LazyImage
            :src="teasing"
            width="85"
            class="u-inline-block u-mr-md"
          />
          <div>
            <Titre
              tag="h2"
              size="sm"
              class="u-my-xs"
            >
              Bientôt disponible
            </Titre>
            <p class="u-font-15">
              Tous vos prochains tickets de caisse seront disponibles ici en présentant votre carte Malin ou en réglant avec votre carte cora Cpay Mastercard en magasin.
            </p>
          </div>
        </div>
      </div>
      <div
        v-else-if="achatsMagasin.length === 0 && (appliedFilters.length > 0 || queryFilters.garantie === '1')"
        class="u-px-md u-py-lg"
      >
        <div class="u-flex u-flex-column u-flex-align-center u-text-center">
          <LazyImage
            :src="noResult"
            width="90"
            class="u-inline-block u-mr-md"
          />
          <div>
            <div>
              <Titre
                tag="h2"
                size="sm"
                class="u-mt-xs u-mb-lg"
              >
                Nous n’avons pas trouvé de ticket de caisse correspondant à vos filtres
              </Titre>
              <div class="u-flex u-flex-column u-flex-align-center">
                <Icon
                  name="info-circle"
                  variant="primary-light"
                  size="sm"
                  class="u-flex-shrink-none u-mr-xs"
                />
                <p class="u-color-text-light u-font-14">
                  Vos tickets de caisse sont conservés pendant une durée de 2 ans
                </p>
              </div>
            </div>

            <div class="u-mt-md">
              <Button
                size="md"
                radius="full"
                variant="primary"
                @click="$emit('supprimerToutFiltres')"
              >
                Réinitialiser les filtres
              </Button>
            </div>
          </div>
        </div>
      </div>
    </Card>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/styles/components/command-list.scss";
</style>
